import { Overgang } from '@/types/deeltrajecten';

import MwdTooltipAankomstRow from './MwdTooltipAankomstRow';
import MwdTooltipVertrekRow from './MwdTooltipVertrekRow';

import styles from './MwdTooltip.module.css';

const calculateOvergangsTijd = (overgang: Overgang) => {
  if (overgang.aankomstTijdVoorgaandeInzet && overgang.vertrekTijdVolgendeInzet) {
    const diff = (overgang.vertrekTijdVolgendeInzet.getTime() - overgang.aankomstTijdVoorgaandeInzet.getTime()) / 60000;
    if (diff < 0) return 0;
    const uren = Math.floor(diff / 60);
    const minuten = Math.round(diff % 60);
    if (uren > 0 && minuten > 0) return ` (${uren} uur en ${minuten} min)`;
    if (uren > 0) return ` (${uren} uur)`;
    return ` (${minuten} min)`;
  }
  return null;
};

const MwdOvergangTooltipContent = ({ data }: { data: Overgang }) => {
  return (
    <div data-testid='mwd-overgang-tooltip' className={styles.mwdTooltipStyleV2}>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
        <span style={{ marginBottom: '4px' }} data-testid='mwd-overgang-tooltip-title'>
          <strong>{data.dienstregelpunt}</strong>
          <span>{calculateOvergangsTijd(data)}</span>
        </span>
        <MwdTooltipAankomstRow
          oorspronkelijkePlanTijd={data.aankomstOorsponkelijkeTijdVoorgaandeInzet || new Date()}
          actuelePlanTijd={data.actueleAankomstTijdVoorgaandeInzet || new Date()}
          uitvoeringsTijd={data.aankomstTijdVoorgaandeInzet || new Date()}
          dienstregelpuntVan={data.dienstregelpunt}
          dienstregelpuntNaar={data.dienstregelpuntVolgendeInzet}
          isOvergang
        />
        <MwdTooltipVertrekRow
          oorspronkelijkePlanTijd={data.vertrekOorsponkelijkeTijdVolgendeInzet || new Date()}
          actuelePlanTijd={data.actueleVertrekTijdVolgendeInzet || new Date()}
          uitvoeringsTijd={data.vertrekTijdVolgendeInzet || new Date()}
          isOvergang
        />
      </div>
    </div>
  );
};

export default MwdOvergangTooltipContent;
